export const PRICING_CONFIG = {
  CHUI_ANNUAL_COST_REP: 10.56, // Updated from pilot rate to Tier 1 standard rate
  REP_DAYS: 180,
  ANNUALIZATION_BASIS: 360, // Standardized for MSME micro-repayment models (30 days * 12)
  
  // Official Tier Matrix as per latest documentation
  PRICING_TIERS: [
    {
      no: 1,
      name: "Micro Starter",
      minSales: 1500,
      maxSales: 3000,
      repaymentPerDay: 500,
      subFee: 4750,
      trancheLimit: 5000,
      totalLimit: 90000,
      trancheDays: 10,
      tranches: 18,
      totalDays: 180,
      rate180: "5.28%",
      rateMonth: "0.88%",
      rateAnnum: "10.56%"
    },
    {
      no: 2,
      name: "Business Scaler",
      minSales: 3000,
      maxSales: 4500,
      repaymentPerDay: 1000,
      subFee: 9500,
      trancheLimit: 10000,
      totalLimit: 180000,
      trancheDays: 10,
      tranches: 18,
      totalDays: 180,
      rate180: "5.28%",
      rateMonth: "0.88%",
      rateAnnum: "10.56%"
    },
    {
      no: 3,
      name: "Market Leader",
      minSales: 4500,
      maxSales: 6000,
      repaymentPerDay: 1500,
      subFee: 14500,
      trancheLimit: 15000,
      totalLimit: 270000,
      trancheDays: 10,
      tranches: 18,
      totalDays: 180,
      rate180: "5.37%",
      rateMonth: "0.90%",
      rateAnnum: "10.74%"
    },
    {
      no: 4,
      name: "Enterprise Hub",
      minSales: 6000,
      maxSales: 7500,
      repaymentPerDay: 2000,
      subFee: 19000,
      trancheLimit: 20000,
      totalLimit: 360000,
      trancheDays: 10,
      tranches: 18,
      totalDays: 180,
      rate180: "5.28%",
      rateMonth: "0.88%",
      rateAnnum: "10.56%"
    },
    {
      no: 5,
      name: "National Impact",
      minSales: 7500,
      maxSales: 9000,
      repaymentPerDay: 2500,
      subFee: 24000,
      trancheLimit: 25000,
      totalLimit: 450000,
      trancheDays: 10,
      tranches: 18,
      totalDays: 180,
      rate180: "5.33%",
      rateMonth: "0.89%",
      rateAnnum: "10.67%"
    }
  ],

  // Competitor Scenarios (Updated to match latest industry benchmarks)
  COMPETITORS: {
    BANKS: { name: "Traditional Banks", avgAnnualRate: 18, processingFee: 3 },
    DIGITAL_LENDERS: { name: "Digital Apps", avgAnnualRate: 150, processingFee: 0 },
    SHYLOCKS: { name: "Informal Lenders", avgAnnualRate: 480, processingFee: 0 }
  },

  getTierBySales: (dailySales: number) => {
    const tier = PRICING_CONFIG.PRICING_TIERS.find(
      t => dailySales >= t.minSales && dailySales <= t.maxSales
    );
    if (tier) return tier;
    if (dailySales < PRICING_CONFIG.PRICING_TIERS[0].minSales) return PRICING_CONFIG.PRICING_TIERS[0];
    return PRICING_CONFIG.PRICING_TIERS[PRICING_CONFIG.PRICING_TIERS.length - 1];
  },

  calculateCompetitorCost: (totalLimit: number, competitorType: 'BANKS' | 'DIGITAL_LENDERS' | 'SHYLOCKS') => {
    const comp = PRICING_CONFIG.COMPETITORS[competitorType];
    const annualRate = comp.avgAnnualRate / 100;
    const cost180Days = totalLimit * (annualRate / 2);
    const processing = totalLimit * (comp.processingFee / 100 || 0);
    return cost180Days + processing;
  },

  // Projections: Assume a conservative 3% compounding revenue gain per 10-day tranche cycle
  projectGrowthBenefit: (initialDailySales: number, tiersRepaid: number = 18) => {
    let currentDaily = initialDailySales;
    const growthPerCycle = 1.03; // 3% growth
    for (let i = 0; i < tiersRepaid; i++) {
      currentDaily *= growthPerCycle;
    }
    return Math.round(currentDaily);
  }
};